import moment from 'moment';

import {
  SET_INSIGHTS_CRITERIA_DATE_RANGE,
  SET_INSIGHTS_CRITERIA_ORGANISATION,
  SET_INSIGHTS_CRITERIA_SUBCATEGORY,
  SET_INSIGHTS_CRITERIA_BOUNDARIES,
  SET_INSIGHTS_CRITERIA_POI,
  SET_INSIGHTS_CRITERIA_MOBILE_APP,
  CLEAR_INSIGHTS_CRITERIA,
  CLEAR_INSIGHTS_CRITERIA_BOUNDARIES,
  CLEAR_INSIGHTS_CRITERIA_POIS,
  CLEAR_INSIGHTS_CRITERIA_MOBILE_APP,
  SET_INSIGHTS_CRITERIA_TYPE,
  SET_INSIGHTS_CRITERIA_FOOTFALL_OVER_TIME_UNIT,
  SET_FROM_LAST_PAGE,
  TOGGLE_STATISTIC_DISPLAY,
  LOG_OUT,
} from '../constants';

import { uniqueId } from '../../utilities/helpers';

const initialState = {
  sinceDate: moment()
    .startOf('day')
    .subtract(30, 'days')
    .format(),
  untilDate: moment()
    .subtract(1, 'days')
    .endOf('day')
    .format(),
  insightType: null,
  organisation: null,
  subcategory: null,
  adm0: null,
  adm1: null,
  adm2: null,
  adm3: null,
  adm4: null,
  poiId: null,
  mobileApp: null,
  baseline: null,
  attribute: null,
  footFallOverTimeUnit: 'day',
  criteriaId: '',
  lastPage: '/',
  isStatisticDisplay: false,
};

const insightsCriteria = (state = initialState, action) => {

  if (action.type === 'SET_CLIENT' && action.data.id === "5dc26da29b7b531cafa425f9") {
    state.sinceDate = moment("20191004", "YYYYMMDD").startOf('day').subtract(30, 'days').format();
    state.untilDate = moment("20191004", "YYYYMMDD").endOf('day').subtract(1, 'days').format();
  }
  switch (action.type) {
    case LOG_OUT:
      return {
        ...initialState,
      };
    case SET_INSIGHTS_CRITERIA_TYPE:
      return {
        ...state,
        insightType: action.insightType,
        criteriaId: uniqueId(),
      };
    case SET_INSIGHTS_CRITERIA_DATE_RANGE:
      return {
        ...state,
        sinceDate: action.sinceDate,
        untilDate: action.untilDate,
      };
    case SET_INSIGHTS_CRITERIA_ORGANISATION:
      return {
        ...state,
        insightType: 'organisation',
        organisation: action.organisation,
        subcategory: action.subcategory,
        criteriaId: uniqueId(),
      };
    case SET_INSIGHTS_CRITERIA_SUBCATEGORY:
      return {
        ...state,
        insightType: 'category',
        subcategory: action.subcategory,
        criteriaId: uniqueId(),
      };
    case SET_INSIGHTS_CRITERIA_BOUNDARIES:
      return {
        ...state,
        adm0: action.boundaries.adm0,
        adm1: action.boundaries.adm1,
        adm2: action.boundaries.adm2,
        adm3: action.boundaries.adm3,
        adm4: action.boundaries.adm4,
        baseline: action.boundaries.baseline,
        attribute: action.boundaries.attribute,
        criteriaId: uniqueId(),
      };
    case SET_INSIGHTS_CRITERIA_POI:
      return {
        ...state,
        poiId: action.poiId,
        criteriaId: uniqueId(),
      };
    case SET_INSIGHTS_CRITERIA_MOBILE_APP:
      return {
        ...state,
        mobileApp: action.mobileApp,
        criteriaId: uniqueId(),
      }
    case CLEAR_INSIGHTS_CRITERIA_BOUNDARIES:
      return {
        ...state,
        adm0: null,
        adm1: null,
        adm2: null,
        adm3: null,
        adm4: null,
        criteriaId: uniqueId(),
      };
    case CLEAR_INSIGHTS_CRITERIA_POIS:
      return {
        ...state,
        poiId: null,
        criteriaId: uniqueId(),
      };
    case CLEAR_INSIGHTS_CRITERIA_MOBILE_APP:
      return {
        ...state,
        mobileApp: null,
        criteriaId: uniqueId(),
      };
    case SET_INSIGHTS_CRITERIA_FOOTFALL_OVER_TIME_UNIT:
      return {
        ...state,
        footFallOverTimeUnit: action.unit,
      };
    case CLEAR_INSIGHTS_CRITERIA:
      return {
        ...state,
        organisation: null,
        subcategory: null,
        regionalArea: null,
        adm1: null,
        adm2: null,
        adm3: null,
        adm4: null,
        poiId: null,
        mobileApp: null,
        criteriaId: uniqueId(),
      };
    case SET_FROM_LAST_PAGE:
      return {
        ...state,
        lastPage: action.lastPage,
      };
    case TOGGLE_STATISTIC_DISPLAY:
      return {
        ...state,
        isStatisticDisplay: !state.isStatisticDisplay,
      };
    default:
      return {
        ...state,
      };
  }
};

export default insightsCriteria;
